import React from 'react';
import styled from 'styled-components';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const PageShell = styled.div`
  font-family: 'Inria Serif', serif;
  padding-top: var(--page-top-spacing, 8px);
`;

const LeadsPageTitle = styled.h1`
  font-family: var(--font-display, 'Inria Serif', serif);
  font-weight: var(--text-page-title-weight, 600);
  font-size: var(--text-page-title-size, 1.5rem);
  color: var(--foreground, #030213);
  margin: 0 0 8px 24px;
  text-align: left;
  letter-spacing: -0.02em;
`;

const InfoText = styled.p`
  font-family: var(--font-body, Inter, sans-serif);
  font-size: 0.9rem;
  color: var(--muted-foreground, #6b7280);
  margin: 0 0 20px 24px;
  line-height: 1.4;
`;

const ToggleWrap = styled.div`
  margin: 0 0 20px 24px;
`;

const PillToggle = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px;
  background: #e9ecef;
  border-radius: 999px;
  gap: 2px;
`;

const PillSegment = styled.button`
  border: none;
  cursor: pointer;
  font-family: 'Inria Serif', serif;
  font-size: 0.9rem;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: #1a1a1a;
  padding: 8px 18px;
  border-radius: 999px;
  background: ${({ $active }) => ($active ? '#fff' : 'transparent')};
  box-shadow: ${({ $active }) => ($active ? '0 1px 3px rgba(0, 0, 0, 0.12)' : 'none')};
  transition: background 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    background: ${({ $active }) => ($active ? '#fff' : 'rgba(255, 255, 255, 0.5)')};
  }
`;

const LeadsPageLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isGroupsPage = location.pathname.includes('/leads/groups');
  const isLeadsBoard = !isGroupsPage;

  return (
    <PageShell>
      <LeadsPageTitle>Leads Dashboard</LeadsPageTitle>
      {isLeadsBoard && (
        <InfoText>
          Cards can be moved manually to any column or will get updated once the status of lead
          changes
        </InfoText>
      )}

      <ToggleWrap>
        <PillToggle role="tablist" aria-label="Leads sections">
          <PillSegment
            type="button"
            role="tab"
            aria-selected={isLeadsBoard}
            $active={isLeadsBoard}
            onClick={() => navigate('/leads')}
          >
            Leads
          </PillSegment>
          <PillSegment
            type="button"
            role="tab"
            aria-selected={isGroupsPage}
            $active={isGroupsPage}
            onClick={() => navigate('/leads/groups')}
          >
            Create/View Groups
          </PillSegment>
        </PillToggle>
      </ToggleWrap>

      <Outlet />
    </PageShell>
  );
};

export default LeadsPageLayout;
